module.exports = __webpack_public_path__ + "static/media/2NZD.8ef81b75.svg";